import { DisplayStrategyConfig, PriceDisplayVersion } from "../constants/priceDisplayStrategy";
import { PageId } from "../types/pageId";
import { PricePresentationType } from "../types/prices";
import { isEachPriceDisplayGroup, isRangePriceDisplayGroup } from "./price-calculator-helper";

export function getPresentationType(priceDisplayGroup: string, presentationType: PricePresentationType, showElev8PricePresentation: boolean, pageId?: PageId): PricePresentationType {
  let configKey;
  let displayStrategyMapKey = PriceDisplayVersion.Legacy;

  if (showElev8PricePresentation) {
    displayStrategyMapKey = PriceDisplayVersion.Current;
  }

  if (pageId) {
    configKey = DisplayStrategyConfig[pageId]?.[displayStrategyMapKey];
  }

  const defaultDisplayStrategy = configKey?.fromGroupStrategy || presentationType;

  // TODO: After Elev8 test, return productPriceDetails.presentationType directly
  if (isEachPriceDisplayGroup(priceDisplayGroup)) {
    return configKey?.eachGroupStrategy || presentationType;
  }

  if (isRangePriceDisplayGroup(priceDisplayGroup)) {
    const strategyKey = presentationType === PricePresentationType.PriceWithQtyAndUnit ? "rangeGroupWithQuantityStrategy" : "rangeGroupStrategy";

    return configKey?.[strategyKey] || presentationType;
  }
  return defaultDisplayStrategy;
}
